import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Item from './ListItem';
import EmptyList from './EmptyList';
import * as shapes from '../shapes';
import withLoadingList from '../../../../common/hoc/withLoaingList';

const DiscountsTable = ({ baseUrl, canModify, currency, discounts }) => {
  const className = classNames('c-table-card c-table-new u-table-layout-fixed', { 'c-no-hover': !canModify });

  return (
    <div>
      <div className={className}>
        <div className="c-table-card__head">
          <div className="c-table-card__cell c-label">Name</div>
          <div className="c-table-card__cell c-label">Value</div>
          <div className="c-table-card__cell c-label">Assignment</div>
        </div>
      </div>
      <div className={className}>
        {discounts.map(discount => (
          <Item
            discount={discount}
            key={discount.id}
            baseUrl={baseUrl}
            disabled={!canModify}
            currency={currency}
          />
        ))}
      </div>
    </div>
  );
};

DiscountsTable.propTypes = {
  baseUrl: shapes.url.isRequired,
  canModify: PropTypes.bool,
  currency: shapes.string,
  discounts: shapes.discounts,
};

DiscountsTable.defaultProps = {
  baseUrl: '/settings/discounts',
  canModify: false,
  currency: 'usd',
  discounts: [],
};

export default withLoadingList(
  props => props.discounts,
  EmptyList,
)(DiscountsTable);
